import {Autocomplete, FormControl, FormControlLabel, Radio, RadioGroup, TextField} from "@mui/material";
import cn from "classnames";
import GoogleMapReact from "google-map-react";
import i18n from "i18next";
import _ from "lodash"
import React, {useCallback, useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {Controller, useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {NotificationManager} from "react-notifications";
import {useAuth} from "react-oidc-context";
import {useDispatch, useSelector} from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import {getAllGasStationAdmins} from "../../actions/admin";
import {addGasStation, getGasStationLabelSuggestion} from "../../actions/gasStation";
import {getAllGasStationManagers, getManagersByAdminId,} from "../../actions/manager";
import {geocodeAddressSetMarkers} from "../../actions/parkingZone";
import {getAllViewers, getViewersByAdminId} from "../../actions/viewer";
import AddressesComponent, {formatAddress} from "../../common/address/AddressesComponent";
import XIcon from "../../common/assets/x-icon.svg";
import Button from "../../common/button/button";
import {isAralDeClientId} from "../../common/client/clientHelper";
import AutoCompleteWithTags from "../../common/input/AutoCompleteWithTags";
import InputController from "../../common/input/inputController";
import InputFieldWithLabel from "../../common/input/inputFieldWithLabel";
import TextareaWithLabel from "../../common/input/textareaWithLabel";
import LabelWithHR from "../../common/labels/labelWithHR";
import {
  ADDRESS_GEOCODING_DELAY,
  aralFuelTypes,
  DebtNoteType,
  defaultAustrianPricingStructure,
  defaultMarker,
  manualParkingZoneMarkerEnabled,
  ROLES
} from "../../consts";
import {newModalStyle} from "../../reusable/styles";
import {currencyCode, formatCurrencyCode} from "../../utils/formatter";
import {mapUser} from "../../utils/mapUser";
import Marker, {colorMapOptions, dimmedMapOptions, moveMapCenterByCountry} from "../parkingZone/marker";
import Style from "./addGasStationModal.module.css";
import PricingStructureTable from "./PricingStructureTable";

const aralFuelTypesTransformed = Object.values(aralFuelTypes);
const AddGasStationModal = (props) => {
  const {handleSubmit, register, watch, control, setValue, getValues, formState: { errors }}
      = useForm({
      mode: "onBlur",
      shouldUnregister: true,
    defaultValues: {
      intentAdditionalFee: 50,
      intentPaymentPeriod: 14,
      intentReminderFee: 10,
      intentReminderPaymentPeriod: 7,
      intentLastReminderFee: 10,
      intentLastReminderPaymentPeriod: 7,
      intentPartialPwfCashAdditionalFee: 50,
      intentPartialPwfCashPaymentPeriod: 14,
      intentPartialPwfCashReminderFee: 20,
      intentPartialPwfCashRemPayPer: 7,
      intentPartialCashLastReminderFee: 10,
      intentPartialCashLastRemPayPer: 7,
      intentPartialPwfCardAdditionalFee: 50,
      intentPartialPwfCardPaymentPeriod: 14,
      intentPartialPwfCardReminderFee: 20,
      intentPartialPwfCardRemPayPer: 7,
      intentPartialCardLastReminderFee: 10,
      intentPartialCardLastRemPayPer: 7,
      intentCardPaymentAdditionalFee: 50,
      intentCardPaymentPaymentPeriod: 14,
      intentCardPaymentReminderFee: 20,
      intentCardPaymentReminderPaymentPeriod: 7,
      intentCardPaymentLastReminderFee: 10,
      intentCardPaymentLastReminderPeriod: 7,
      promissoryNotePaymentFee: 10,
      promissoryNoteGracePeriod: 3,
      promissoryNoteAdditionalFee: 50,
      promissoryNotePaymentPeriod: 14,
      promissoryNoteReminderFee: 10,
      promissoryNoteReminderPaymentPeriod: 7,
      promissoryNoteLastReminderFee: 10,
      promissoryNoteLastReminderPeriod: 7,
      debtNoteAdditionalFee: 50,
      debtNotePaymentPeriod: 14,
      debtNoteReminderFee: 10,
      debtNoteReminderPaymentPeriod: 7,
      debtNoteLastReminderFee: 10,
      debtNoteLastReminderPeriod: 7,
      pumpSwappedAdditionalFee: 50,
      pumpSwappedPaymentPeriod: 14,
      pumpSwappedReminderFee: 10,
      pumpSwappedReminderPaymentPeriod: 7,
      pumpSwappedLastReminderFee: 10,
      pumpSwappedLastReminderPeriod: 7,
      otherReasonAdditionalFee: 50,
      otherReasonPaymentPeriod: 14,
      otherReasonReminderFee: 10,
      otherReasonReminderPaymentPeriod: 7,
      otherReasonLastReminderFee: 10,
      otherReasonLastReminderPeriod: 7,
      serviceFee: 20,
      holderDataRetrieval: 5.10,
      invoicePaymentPeriod: 14,
      reminderPaymentPeriod: 7,
      lastReminderPaymentPeriod: 7,
      rvgMultiplierInvoice: 0.5,
      rvgMultiplierReminder: 0.9,
      rvgMultiplierLastReminder: 0.9,
      baseFee: 51.50,
      capBelow50: 31.50,
      waitingPeriod: 3
    }
  });
  const { t } = useTranslation();
  const auth = useAuth();
  const loggedUser = mapUser(auth);
  const dispatch = useDispatch();

  const { admins } = useSelector((state) => state.admin);
  const { managers } = useSelector((state) => state.manager);
  const { viewers } = useSelector((state) => state.viewer);
  const { clients } = useSelector((state) => state.client);

  const [managersIds, setManagersIds] = useState([]);
  const [viewersIds, setViewersIds] = useState([]);
  const [clientId, setClientId] = useState("");
  const [powerOfAttorneyName, setPowerOfAttorneyName] = useState("");
  const [powerOfAttorney, setPowerOfAttorney] = useState(null);
  const [documentation, setDocumentation] = useState(null);
  const [documentationName, setDocumentationName] = useState("");
  const [managersComboBoxNames, setManagersComboBoxNames] = useState([]);
  const [viewersComboBoxNames, setViewersComboBoxNames] = useState([]);
  const [contractDate, setContractDate] = useState(null);
  const [useClientDocs, setUseClientDocs] = useState(false);
  const [counter, setCounter] = useState(0);
  const [interruptAutoBillingGeneration, setInterruptAutoBillingGeneration] = useState(false);
  const [hdStatusAutomation, setHdStatusAutomation] = useState(false);
  const [debtNoteType, setDebtNoteType] = useState(DebtNoteType.GAS_STATION);
  const [markers, setMarkers] = useState([]);
  const [geocoder, setGeocoder] = useState(null);
  const [map, setMap] = useState();

  const labelSuggestions = useSelector(state => clientId ? state.gasStation?.gasStationLabelSuggestions || [] : []);

  const isLoggedUserSysadmin = loggedUser?.roles?.includes(ROLES.SYSADMIN);

  const [keycloakAdminId, setKeycloakAdminId] = useState("0");

  const name = watch("name");

  const [categoryPaymentDetails, setCategoryPaymentDetails]
      = useState({

  });
  const customer = watch("customer");
  const [selectedLabels, setSelectedLabels] = useState([]);

  const [address, setAddress] = useState(null);
  const internationalFee = watch("internationalFee");
  const waitingPeriod = watch("waitingPeriod");
  const clientName = watch("clientName");
  const clientNumber = watch("clientNumber");
  const profitCenter = watch("profitCenter");
  const costCenter = watch("costCenter");
  const iban = watch("iban");
  const bic = watch("bic");
  const payee = watch("payee");
  const financialInstitution = watch("financialInstitution");
  const salesArea = watch("salesArea");
  const others = watch("others");
  const notedBy = watch("notedBy");
  const injuredPerson = watch("injuredPerson");
  const representedBy = watch("representedBy");
  const relationToProperty = watch("relationToProperty");
  const additionalInfo = watch("additionalInfo");
  const countryWatch = watch("country", "0");
  const externalReferenceId = watch("externalReferenceId");
  const serviceFee = watch("serviceFee");
  const holderDataRetrieval = watch("holderDataRetrieval");
  const invoicePaymentPeriod = watch("invoicePaymentPeriod");
  const reminderPaymentPeriod = watch("reminderPaymentPeriod");
  const lastReminderPaymentPeriod = watch("lastReminderPaymentPeriod");
  const rvgMultiplierInvoice = watch("rvgMultiplierInvoice");
  const rvgMultiplierReminder = watch("rvgMultiplierReminder");
  const rvgMultiplierLastReminder = watch("rvgMultiplierLastReminder");
  const baseFee = watch("baseFee");
  const capBelow50 = watch("capBelow50");

  const [fuelTypesSelected, setFuelTypesSelected] = useState(
    aralFuelTypesTransformed.reduce((acc, element) => ({ ...acc, [element]: false }), {})
  );

  const isSelectedCountryDE = () => countryWatch === "DE";
  const isSelectedCountryAT = () => countryWatch === "AT";
  const isSelectedCountryCH = () => countryWatch === "CH";  
  const handleWaitingPeriod = (value) => {
    setValue("waitingPeriod", isAralDeClientId(value)? 7 : 3);
  };
  const [pricingStructure, setPricingStructure] = useState(null);
  const resetSelectedFuelTypes = () => {
    setFuelTypesSelected(
      aralFuelTypesTransformed.reduce((acc, name) => {
        acc[name] = false;
        return acc;
      }, {})
    );
  };
  const handleFuelTypesChange = (name, value) => {
    setFuelTypesSelected((prevStates) => {
      const newState = { ...prevStates, [name]: value };
      return newState;
    });
  };

  useEffect(() => moveMapCenterByCountry(markers, countryWatch, map), [countryWatch]);
  useEffect(() => {
    if (isSelectedCountryAT()) {
      setPricingStructure(defaultAustrianPricingStructure);
    } else {
      setPricingStructure(null);
    }
  }, [countryWatch]);

  const updatePricingValue = (fuelTypeIndex, field, value) => {
    const updatedStructure = { ...pricingStructure };
    updatedStructure.fuelTypes[fuelTypeIndex] = {
      ...updatedStructure.fuelTypes[fuelTypeIndex],
      [field]: parseFloat(value) || 0
    };
    setPricingStructure(updatedStructure);
  };

  const memoizedDebouncedGeocoding = useCallback(
      _.debounce((map, geocoder, address, setMarkersCallback) => {

            const formattedAddress = formatAddress(address);
            NotificationManager.info(t('EditParkingZoneModal.geocodingAddressLong', {formattedAddress: formattedAddress}), t('EditParkingZoneModal.geocodingAddress'), 1500);
            geocodeAddressSetMarkers(map, geocoder, address, setMarkersCallback)
                .then(_ => {
                  // loader...
                })
                .finally({
                  // loader

                })
          },
          ADDRESS_GEOCODING_DELAY), []);

      const onAddressAdded = (newAddress) => {
        setAddress(newAddress);

        if (newAddress) {
          // address is valid, begin geocoding sometimes in the future
          memoizedDebouncedGeocoding(map, geocoder, newAddress, setMarkers);
        }
      }

  const isAdminSelected = () => {
    return isLoggedUserSysadmin ? keycloakAdminId === "0" : false;
  };

  const isSubmitDisabled =
    !address || !name || isAdminSelected() ||
      managersIds?.includes("0") || viewersIds?.includes("0");

  useEffect(() => {
    if (isLoggedUserSysadmin) {
      dispatch(getAllGasStationAdmins());
      dispatch(getAllGasStationManagers());
      dispatch(getAllViewers());
    } else {
      dispatch(getManagersByAdminId());
      dispatch(getViewersByAdminId());
    }
  }, [dispatch, isLoggedUserSysadmin]);

  const setGasStationAdmin = (id) => {
    setKeycloakAdminId(id);
  };

  const renderManagers = () => {
    const getListOfManagers = (managers, ordinalNumber) => {
      if (ordinalNumber === 1) return managers;
      return managers.filter(
        (m) => !managersIds.slice(0, ordinalNumber - 1).includes(m.id)
      );
    };

    return (
      <div>
        {managersIds.map((manager, index) => {
          const ordinalNumber = index + 1;

          return (
            <div key={index} className={Style.manager}>
              <div className={Style.manager__select}>
                <Controller
                    name={`parkingZoneManager_${managersComboBoxNames[index]}`}
                    control={control}
                    render={() => (
                        <Autocomplete
                            size="small"
                            className={Style.textStyleSelectEditModal}
                            id={`parkingZoneManager_${managersComboBoxNames[index]}`}
                            onChange={(e,value)  => {
                              if(value) {
                                managersIds[index] = value.id;
                                setManagersIds([...managersIds]);
                              }
                            }}
                            disableClearable
                            value = {managers.find(x=>x.id===manager) || null}
                            renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                            options={getListOfManagers(managers, ordinalNumber).filter((m) => m.id !== keycloakAdminId)}
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName?"| "+x.companyName:""}`}
                        />
                    )}
                />
              </div>
              <div className={Style.manager__removeBtn}>
                <img
                  alt=""
                  src={XIcon}
                  height="25px"
                  width="25px"
                  onClick={(e) => {
                    setManagersIds([
                      ...managersIds.filter((m, i) => i !== index),
                    ]);
                    managersComboBoxNames.splice(index, 1);
                    setManagersComboBoxNames([...managersComboBoxNames]);
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const renderViewers = () => {
    const getListOfViewers = (viewers, ordinalNumber) => {
      if (ordinalNumber === 1) return viewers;
      return viewers.filter(
          (m) => !viewersIds.slice(0, ordinalNumber - 1).includes(m.id)
      );
    };

    return (
        <div>
          {viewersIds.map((viewer, index) => {
            const ordinalNumber = index + 1;

            return (
                <div key={index} className={Style.manager}>
                  <div className={Style.manager__select}>
                    <Controller
                        name={`parkingZoneViewer_${viewersComboBoxNames[index]}`}
                        control={control}
                        render={() => (
                            <Autocomplete
                                size="small"
                                className={Style.textStyleSelectEditModal}
                                id={`parkingZoneManager_${viewersComboBoxNames[index]}`}
                                onChange={(e,value)  => {
                                  if(value) {
                                    viewersIds[index] = value.id;
                                    setViewersIds([...viewersIds]);
                                  }
                                }}
                                disableClearable
                                value = {viewers.find(x=>x.id===viewer) || null}
                                renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                                options={getListOfViewers(viewers, ordinalNumber).filter((m) => m.id !== keycloakAdminId)}
                                getOptionSelected={(option, value) => option.id === value.id}
                                getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName?"| "+x.companyName:""}`}
                            />
                        )}
                    />
                  </div>
                  <div className={Style.manager__removeBtn}>
                    <img
                        alt=""
                        src={XIcon}
                        height="25px"
                        width="25px"
                        onClick={(e) => {
                          setViewersIds([
                            ...viewersIds.filter((m, i) => i !== index),
                          ]);
                          viewersComboBoxNames.splice(index, 1);
                          setViewersComboBoxNames([...viewersComboBoxNames]);
                        }}
                    />
                  </div>
                </div>
            );
          })}
        </div>
    );
  };

  const documentUpload = (e, files, setFiles, filesNames, setFilesNames, isSingleFile) => {
    if (e.target.files.length !== 0) {
        let fileList = files === null ? [] : files;
        let names = filesNames;
        for (let i = 0; i < e.target.files.length; i++) {
          if (isSingleFile && i === 0) {
            fileList = [];
            fileList.push(e.target.files[i])
            names = e.target.files[i].name;
          } else {
            fileList.push(e.target.files[i]);
            names = names === "" ? e.target.files[i].name : names.concat("|", e.target.files[i].name);
          }
        }
        setFiles(fileList);
        setFilesNames(names);
      }
  };

  const saveGasStation = async (data) => {
    const formData = new FormData();

    for (let i = 0; i < powerOfAttorney?.length; i++) {
      formData.append("powerOfAttorney", powerOfAttorney[i]);
    }
    formData.append("powerOfAttorneyName", powerOfAttorneyName);
    for (let i = 0; i < documentation?.length; i++) {
      formData.append("documentation", documentation[i]);
    }
    formData.append("documentationName", documentationName);



    const {
      intentAdditionalFee,
      intentPaymentPeriod,
      intentReminderFee,
      intentReminderPaymentPeriod,
      intentLastReminderFee,
      intentLastReminderPaymentPeriod,
      intentPartialPwfCashAdditionalFee,
      intentPartialPwfCashPaymentPeriod,
      intentPartialPwfCashReminderFee,
      intentPartialPwfCashRemPayPer,
      intentPartialCashLastReminderFee,
      intentPartialCashLastRemPayPer,
      intentPartialPwfCardAdditionalFee,
      intentPartialPwfCardPaymentPeriod,
      intentPartialPwfCardReminderFee,
      intentPartialPwfCardRemPayPer,
      intentPartialCardLastReminderFee,
      intentPartialCardLastRemPayPer,
      intentCardPaymentAdditionalFee,
      intentCardPaymentPaymentPeriod,
      intentCardPaymentReminderFee,
      intentCardPaymentReminderPaymentPeriod,
      intentCardPaymentLastReminderFee,
      intentCardPaymentLastReminderPeriod,
      promissoryNotePaymentFee,
      promissoryNoteGracePeriod,
      promissoryNoteAdditionalFee,
      promissoryNotePaymentPeriod,
      promissoryNoteReminderFee,
      promissoryNoteReminderPaymentPeriod,
      promissoryNoteLastReminderFee,
      promissoryNoteLastReminderPeriod,
      debtNoteAdditionalFee,
      debtNotePaymentPeriod,
      debtNoteReminderFee,
      debtNoteReminderPaymentPeriod,
      debtNoteLastReminderFee,
      debtNoteLastReminderPeriod,
      pumpSwappedAdditionalFee,
      pumpSwappedPaymentPeriod,
      pumpSwappedReminderFee,
      pumpSwappedReminderPaymentPeriod,
      pumpSwappedLastReminderFee,
      pumpSwappedLastReminderPeriod,
      otherReasonAdditionalFee,
      otherReasonPaymentPeriod,
      otherReasonReminderFee,
      otherReasonReminderPaymentPeriod,
      otherReasonLastReminderFee,
      otherReasonLastReminderPeriod,
    } = data;
    const categoryPaymentDetails = {
      intentAdditionalFee: countryWatch != "AT" ? intentAdditionalFee : 0,
      intentPaymentPeriod: countryWatch != "AT" ? intentPaymentPeriod : 0,
      intentReminderFee: countryWatch != "AT" ? intentReminderFee : 0,
      intentReminderPaymentPeriod: countryWatch != "AT" ? intentReminderPaymentPeriod : 0,
      intentLastReminderFee: countryWatch != "AT" ? intentLastReminderFee : 0,
      intentLastReminderPaymentPeriod: countryWatch !== "AT" ? intentLastReminderPaymentPeriod : 0,
      promissoryNotePaymentFee: countryWatch != "AT" ? promissoryNotePaymentFee : 0,
      promissoryNoteGracePeriod: countryWatch != "AT" ? promissoryNoteGracePeriod : 0,
      promissoryNoteAdditionalFee: countryWatch != "AT" ? promissoryNoteAdditionalFee : 0,
      promissoryNotePaymentPeriod: countryWatch != "AT" ? promissoryNotePaymentPeriod : 0,
      promissoryNoteReminderFee: countryWatch != "AT" ? promissoryNoteReminderFee : 0,
      promissoryNoteReminderPaymentPeriod: countryWatch != "AT" ? promissoryNoteReminderPaymentPeriod : 0,
      promissoryNoteLastReminderFee: countryWatch != "AT" ? promissoryNoteLastReminderFee : 0,
      promissoryNoteLastReminderPeriod: countryWatch != "AT" ? promissoryNoteLastReminderPeriod : 0,
      debtNoteAdditionalFee: countryWatch == "CH" ? debtNoteAdditionalFee : 0,
      debtNotePaymentPeriod: countryWatch == "CH" ? debtNotePaymentPeriod : 0,
      debtNoteReminderFee: countryWatch == "CH" ? debtNoteReminderFee : 0,
      debtNoteReminderPaymentPeriod: countryWatch == "CH" ? debtNoteReminderPaymentPeriod : 0,
      debtNoteLastReminderFee: countryWatch == "CH" ? debtNoteLastReminderFee : 0,
      debtNoteLastReminderPeriod: countryWatch == "CH" ? debtNoteLastReminderPeriod : 0,
      pumpSwappedAdditionalFee: countryWatch == "CH" ? pumpSwappedAdditionalFee : 0,
      pumpSwappedPaymentPeriod: countryWatch == "CH" ? pumpSwappedPaymentPeriod : 0,
      pumpSwappedReminderFee: countryWatch == "CH" ? pumpSwappedReminderFee : 0,
      pumpSwappedReminderPaymentPeriod: countryWatch == "CH" ? pumpSwappedReminderPaymentPeriod : 0,
      pumpSwappedLastReminderFee: countryWatch == "CH" ? pumpSwappedLastReminderFee : 0,
      pumpSwappedLastReminderPeriod: countryWatch == "CH" ? pumpSwappedLastReminderPeriod : 0,
      otherReasonAdditionalFee: countryWatch != "AT" ? otherReasonAdditionalFee : 0,
      otherReasonPaymentPeriod: countryWatch != "AT" ? otherReasonPaymentPeriod : 0,
      otherReasonReminderFee: countryWatch != "AT" ? otherReasonReminderFee : 0,
      otherReasonReminderPaymentPeriod: countryWatch != "AT" ? otherReasonReminderPaymentPeriod : 0,
      otherReasonLastReminderFee: countryWatch != "AT" ? otherReasonLastReminderFee : 0,
      otherReasonLastReminderPeriod: countryWatch != "AT" ? otherReasonLastReminderPeriod : 0,
    };

    const newGasStation = {
      name,
      categoryPaymentDetails,
      customer,
      address,
      adminKeycloakId: isLoggedUserSysadmin ? keycloakAdminId : loggedUser.id,
      managersIds,
      viewersIds,
      clientId,
      useClientDocs,
      internationalFee: !isSelectedCountryAT()? internationalFee : 0,
      waitingPeriod,
      clientName,
      clientNumber,
      profitCenter,
      costCenter,
      iban,
      bic,
      payee,
      financialInstitution,
      contractDate,
      salesArea,
      others,
      notedBy,
      injuredPerson,
      representedBy,
      relationToProperty,
      additionalInfo,
      externalReferenceId,
      serviceFee: isSelectedCountryDE() ? serviceFee : null,
      holderDataRetrieval: isSelectedCountryDE() ? holderDataRetrieval : null,
      invoicePaymentPeriod: !isSelectedCountryCH() ? invoicePaymentPeriod : null,
      reminderPaymentPeriod: !isSelectedCountryCH() ? reminderPaymentPeriod : null,
      lastReminderPaymentPeriod: !isSelectedCountryCH() ? lastReminderPaymentPeriod : null,
      rvgMultiplierInvoice: isSelectedCountryDE() ? rvgMultiplierInvoice : null,
      rvgMultiplierReminder: isSelectedCountryDE() ? rvgMultiplierReminder : null,
      rvgMultiplierLastReminder: isSelectedCountryDE() ? rvgMultiplierLastReminder : null,
      baseFee: isSelectedCountryDE() ? baseFee : null,
      capBelow50: isSelectedCountryDE() ? capBelow50 : null,
      interruptAutoBilling: interruptAutoBillingGeneration,
      hdStatusAutomation,
      debtNoteType: debtNoteType,
      labelNames: selectedLabels,
      pricingStructure,
      marker: markers.length > 0
        ? { latitude: markers[0].center.lat, longitude: markers[0].center.lng }
        : null
    };

    for (let i = 0; i < aralFuelTypesTransformed.length; i++) {
      if(fuelTypesSelected[aralFuelTypesTransformed[i]]) {
        newGasStation.aralFuelTypes =  (newGasStation.aralFuelTypes? newGasStation.aralFuelTypes : "")  + aralFuelTypesTransformed[i] + ',';
      }
    }
    if (newGasStation.aralFuelTypes!=null && newGasStation.aralFuelTypes.charAt( newGasStation.aralFuelTypes.length-1)===',') {
      newGasStation.aralFuelTypes = newGasStation.aralFuelTypes.substring(0, newGasStation.aralFuelTypes.length-1);
    }
    console.log('Pricing Structure being sent:', JSON.stringify(pricingStructure, null, 2));
    console.log('Full newGasStation object:', JSON.stringify(newGasStation, null, 2));
  
    formData.append(
      "gasStationZone",
      new Blob([JSON.stringify(newGasStation)], {
        type: "application/json",
      })
    );

    dispatch(addGasStation(formData, props.onClose));
  };

  const removeDocument = (
    files,
    setFiles,
    filesNames,
    setFilesNames,
    index
  ) => {
    setFiles([...files?.filter((f, i) => i !== index)]);
    const namesArray = filesNames?.split("|");
    namesArray.splice(index, 1);
    setFilesNames(namesArray?.join("|"));
  };

  const showDocumentsNames = (files, setFiles, filesNames, setFilesNames) => {
    return filesNames?.split("|")?.map((n, index) => (
      <div key={index} className={Style.uploadedFile}>
        <div className={Style.uploadedFile__name}>{n}</div>
        <div className={Style.uploadedFile__line} />
        <div className={Style.uploadedFile__removeBtn}>
          <img
            alt=""
            src={XIcon}
            height="25px"
            width="25px"
            onClick={() => {
              removeDocument(files, setFiles, filesNames, setFilesNames, index);
            }}
          />
        </div>
      </div>
    ));
  };

  const currencyDisplay = formatCurrencyCode(countryWatch)

  const internationalFeeLabel = t("GasStations.internationalFee") + " " + currencyDisplay;
  const additionalFeeLabel = t("GasStations.additionalFee") + " " + currencyDisplay;
  const reminderFeeLabel = t("GasStations.reminderFee")  + " " + currencyDisplay;
  const lastReminderFeeLabel = t("GasStations.lastReminderFee")  + " " + currencyDisplay;
  const paymentFeeLabel = t("GasStations.paymentFee") + " " + currencyDisplay;
  const serviceFeeLabel = t("GasStations.serviceFee") + " " + currencyDisplay;
  const holderDataRetrievalLabel = t("GasStations.holderDataRetrieval") + " " + currencyDisplay;
  const baseFeeLabel = t("GasStations.baseFee") + " " + currencyCode(countryWatch);
  const capBelow50Label = t("GasStations.capBelow50") + " " + currencyCode(countryWatch);


  return (
    <Modal
        open={props.open}
        closeOnEsc
        onClose={props.onClose}
        center
        styles={newModalStyle({width: "70%", maxWidth: "900px"})}
    >
      <div className="modal__headerLine"/>
      <div className={cn("modal__title", Style.modal__title)}>
        {props.title}
      </div>

      <form onSubmit={handleSubmit((data) => saveGasStation(data))}>
        <div className={Style.formContainer}>
          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.basicInfo")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <div className={Style.gsNameContainer}>
                <InputFieldWithLabel
                    label={t("GasStations.gsName")}
                    name="name"
                    registerName="name"
                    register={register}
                    required={true}
                />
              </div>

              {/*put client name to this row if there is no client entity*/}
              {!isAralDeClientId(clientId) &&
                  <div className={Style.gsPaymentPeriodContainer}>
                    <InputFieldWithLabel
                        label={t("Clients.Client")}
                        name="customer"
                        registerName="customer"
                        register={register}
                        type="text"
                        disabled={clientId}
                    />
                  </div>}
            </div>

            {isAralDeClientId(clientId) &&
                <div className={Style.gsPaymentInfoContainer}>
                  <div className={cn(Style.gsNameContainer)}>
                    <InputFieldWithLabel
                        label={t("EditGasStationModal.externalReferenceId", { customer })}
                        name="externalReferenceId"
                        type="number"
                        registerName="externalReferenceId"
                        register={register}
                    />
                  </div>

                  <div className={cn(Style.gsPaymentPeriodContainer)}>
                    <InputFieldWithLabel
                        label={t("Clients.Client")}
                        name="customer"
                        type="text"
                        registerName="customer"
                        register={register}
                        disabled
                    />
                  </div>
                </div>}


            <div className={Style.gsPaymentInfoContainer}>
              <div className={Style.gsNameContainer}>
                <InputFieldWithLabel
                    className={"container--margineRight"}
                    label={t("GasStationDetailsModal.clientNumber")}
                    name="clientNumber"
                    registerName="clientNumber"
                    register={register}
                    type="text"
                />
              </div>
              <div className={Style.gsPaymentPeriodContainer}>
                <InputFieldWithLabel
                    label={t("GasStationDetailsModal.clientName")}
                    name="clientName"
                    registerName="clientName"
                    register={register}
                    type="text"
                />
              </div>
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={Style.gsNameContainer}>
                <InputFieldWithLabel
                    className={"container--margineRight"}
                    label={t("GasStationDetailsModal.profitCenter")}
                    name="profitCenter"
                    registerName="profitCenter"
                    register={register}
                    type="text"
                />
              </div>
              <div className={Style.gsPaymentPeriodContainer}>
                <InputFieldWithLabel
                    label={t("GasStationDetailsModal.costCenter")}
                    name="costCenter"
                    registerName="costCenter"
                    register={register}
                    type="text"
                />
              </div>
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={Style.gsNameContainer}>
                {!isSelectedCountryAT() && <InputFieldWithLabel
                    className={"container--margineRight"}
                    label={internationalFeeLabel}
                    name="internationalFee"
                    registerName="internationalFee"
                    register={register}
                    type="number"
                    min={0}
                />}
              </div>
                <div className={Style.gsPaymentPeriodContainer}>
                  <InputFieldWithLabel
                      className={"container--margineRight"}
                      label={t("GasStations.waitingPeriod")}
                      name="waitingPeriod"
                      registerName="waitingPeriod"
                      register={register}
                      type="number"
                      required={true}
                      min={0}
                  />
                </div>
            </div>
            <div className={Style.customInputsContainer}>
              <div className="objectionEnabledCheckbox">
                <input
                    type="checkbox"
                    className="checkboxObjectionEnabled"
                    onChange={() => {
                      setInterruptAutoBillingGeneration(
                          !interruptAutoBillingGeneration
                      );
                    }}
                    checked={interruptAutoBillingGeneration}
                />
                <div
                    className="objectionEnabled"
                    style={{ fontSize: 14 }}
                >
                  {t("GasStations.interruptAutoBillingGeneration")}
                </div>
              </div>

              <div className="objectionEnabledCheckbox">
                <input
                  type="checkbox"
                  className="checkboxObjectionEnabled"
                  onChange={() => setHdStatusAutomation(!hdStatusAutomation)}
                  checked={hdStatusAutomation}
                />
                <div className="objectionEnabled" style={{ fontSize: 14 }}>
                  {t("GasStations.hdStatusAutomation")}
                </div>
              </div>

            </div>

            <div className={Style.customInputsContainer}>
              <FormControl component="fieldset" style={{ width: "100%" }}>
                <LabelWithHR label={t("GasStations.debtNoteType")}/>
                <RadioGroup
                  name="debtNoteType"
                  value={debtNoteType}
                  onChange={(e) => setDebtNoteType(e.target.value)}
                  row
                >
                  <FormControlLabel
                    value={DebtNoteType.BEPPO}
                    control={<Radio />}
                    label={t("GasStations.DebtNoteType.BEPPO")}
                  />
                  <FormControlLabel
                    value={DebtNoteType.GAS_STATION}
                    control={<Radio />}
                    label={t("GasStations.DebtNoteType.GAS_STATION")}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          <div className={Style.section}>
            <AddressesComponent
                onAddressAdded={onAddressAdded}
                watch={watch}
                register={register}
                errors={errors}
            />
            <LabelWithHR label={t("GasStations.location")}/>
            <div className={Style.section__map}>
              <GoogleMapReact
                  defaultCenter={defaultMarker.center}
                  defaultZoom={defaultMarker.zoom}
                  yesIWantToUseGoogleMapApiInternals
                  options={markers.length > 0 ? colorMapOptions : dimmedMapOptions}
                  onClick={(value) => {
                    if (!manualParkingZoneMarkerEnabled) {
                      return;
                    }

                    if (markers.length > 0) {
                      return;
                    }
                    setMarkers([
                      ...markers,
                      {
                        center: {lat: value.lat, lng: value.lng}
                      },
                    ]);
                  }}
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAPS_KEY,
                    libraries: ["geocoding"],
                    language: i18n.language,
                  }}
                  onGoogleApiLoaded={({map, maps}) => {
                    setMap(map);
                    setGeocoder(new maps.Geocoder());
                  }}
              >
                {markers?.map((marker) => (
                    <Marker
                        lat={marker.center.lat}
                        lng={marker.center.lng}
                        onClick={() => {
                          if (!manualParkingZoneMarkerEnabled) {
                            return;
                          }
                          setMarkers([])
                        }}
                    />
                ))}
              </GoogleMapReact>
            </div>
          </div>

          <div className={Style.section} >
            <div
                className={cn(
                    Style.section__title,
                    Style["section__title--admin"]
                )}
            >
              {t("Clients.Client")}
            </div>

            {isLoggedUserSysadmin ? (
                <div>
                  <div className={Style.manager}>
                    <div className={Style.manager__select}>
                      <Controller
                          name="clientId"
                          control={control}
                          render={() => (
                              <Autocomplete
                                  size="small"
                                  id={"clientId"}
                                  onChange={(e, value) => {
                                    if (value) {
                                      setClientId(value.id);
                                      setValue("customer", `${value.name}`);
                                      handleWaitingPeriod(value.id);
                                      dispatch(getGasStationLabelSuggestion(value.id));
                                    }
                                  }}
                                  disableClearable
                                  value={clients.find(x => x.id === clientId) || null}
                                  renderInput={(params) => <TextField {...params} placeholder={t("Clients.Choose")}/>}
                                  options={clients}
                                  getOptionSelected={(option, value) => option.id === value.id}
                                  getOptionLabel={(x) => `${x.name} | ${x.representativeName}`}
                              />
                          )}
                      />
                    </div>
                    <div className={Style.manager__removeBtn} onClick={() => {
                      setClientId(null);
                      setUseClientDocs(false);
                      setValue("customer", "");
                    }}>
                      <img
                          alt=""
                          src={XIcon}
                          height="25px"
                          width="25px"
                      />
                    </div>
                  </div>
                  <div className="objectionEnabledCheckbox">
                    <input
                        type="checkBox"
                        className="checkboxObjectionEnabled"
                        disabled={!clientId}
                        onChange={() => {
                          setUseClientDocs(
                              !useClientDocs
                          );
                        }}
                        checked={useClientDocs}
                    />
                    <div
                        className="objectionEnabled"
                        style={{fontSize: 14}}
                    >
                      {t("Clients.UseClientDocs")}
                    </div>
                  </div>
                </div>
            ) : (
                <div className={Style.text}>
                  {clients.find(client => client.id === clientId)?.name || ""}
                </div>
            )}
            <AutoCompleteWithTags
              suggestions={labelSuggestions || []}
              selectedValues={selectedLabels}
              label={t("GasStations.labels")}
              placeholder={t("GasStations.labelPlaceholderText")}
              onSelectionChange={(selectedValues) => {
                console.log('Selected labels:', selectedValues);
                setSelectedLabels(selectedValues);
              }}
            />
          </div>
          <PricingStructureTable 
            pricingStructure={pricingStructure}
            currencyDisplay={currencyDisplay}
            onPricingValueUpdate={updatePricingValue}
            countryCode={countryWatch}
          />
          {isAralDeClientId(clientId) && (
            <div className={Style.section}>
              <div className={Style.section__title}>
                {t("GasStations.fuelTypesTitle")}
              </div>
              <div  className="fuel-checkbox-container">
              {aralFuelTypesTransformed.map((value, index) => (
                  <div className="objectionEnabledCheckbox">
                    <input
                        key={index}
                        type="checkBox"
                        className="checkboxObjectionEnabled"
                        disabled={!clientId}
                        onChange={(e) => handleFuelTypesChange(value, e.target.checked)}
                        checked={fuelTypesSelected[value]}
                    />
                    <div
                        className="objectionEnabled"
                        style={{fontSize: 14}}
                    >
                      {value}
                    </div>
                  </div>
              ))}
              </div>
            </div>
          )}
          {!isSelectedCountryAT() && !isSelectedCountryDE()  ? (
          <>
          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.inetntPaymentInfoTitle")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"],
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={additionalFeeLabel}
                  name={"intentAdditionalFee"}
                  registerName={"intentAdditionalFee"}
                  register={register}
                  type="number"
                  min={0}
                />
              </div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.paymentPeriod")}
                  name={"intentPaymentPeriod"}
                  registerName={"intentPaymentPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={reminderFeeLabel}
                  name={"intentReminderFee"}
                  registerName={"intentReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.reminderPaymentPeriod")}
                  name={"intentReminderPaymentPeriod"}
                  registerName={"intentReminderPaymentPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={lastReminderFeeLabel}
                  name={"intentLastReminderFee"}
                  registerName={"intentLastReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.lastReminderPaymentPeriod")}
                  name={"intentLastReminderPaymentPeriod"}
                  registerName={"intentLastReminderPaymentPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
          </div>


          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.promissoryNotePaymentInfoTitle")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
                <InputController
                    containerStyles={cn(
                        Style.container,
                        Style["container--margineRight"]
                    )}
                    label={paymentFeeLabel}
                    name={"promissoryNotePaymentFee"}
                    control={control}
                    controllerClassName={Style.textStyleInputEditModal}
                    type={"number"}
                    min={0}
                    onChange={(e) => {
                      setCategoryPaymentDetails({
                        ...categoryPaymentDetails,
                        promissoryNotePaymentFee: e.target.value,
                      });
                    }}
                />

                <InputController
                   containerStyles={Style.container}
                    label={t("GasStations.gracePeriod")}
                    name={"promissoryNoteGracePeriod"}
                    control={control}
                    controllerClassName={Style.textStyleInputEditModal}
                    type={"number"}
                    min={0}
                    onChange={(e) => {
                      setCategoryPaymentDetails({
                        ...categoryPaymentDetails,
                        promissoryNoteGracePeriod: e.target.value,
                      });
                    }}
                />
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={additionalFeeLabel}
                  name={"promissoryNoteAdditionalFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      promissoryNoteAdditionalFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.paymentPeriod")}
                  name={"promissoryNotePaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      promissoryNotePaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={reminderFeeLabel}
                  name={"promissoryNoteReminderFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      promissoryNoteReminderFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.reminderPaymentPeriod")}
                  name={"promissoryNoteReminderPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      promissoryNoteReminderPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={lastReminderFeeLabel}
                  name={"promissoryNoteLastReminderFee"}
                  registerName={"promissoryNoteLastReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.lastReminderPaymentPeriod")}
                  name={"promissoryNoteLastReminderPeriod"}
                  registerName={"promissoryNoteLastReminderPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
          </div>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.debtNotePaymentInfoTitle")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={additionalFeeLabel}
                  name={"debtNoteAdditionalFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      debtNoteAdditionalFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.paymentPeriod")}
                  name={"debtNotePaymentPeriod"}
                  rules={{
                    validate: (value) => getValues("country") !== "CH" || Number(value) >= 1
                        || t("Validation.debtNotePaymentPeriodMinCh"),
                  }}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      debtNotePaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={reminderFeeLabel}
                  name={"debtNoteReminderFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      debtNoteReminderFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.reminderPaymentPeriod")}
                  name={"debtNoteReminderPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      debtNoteReminderPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={lastReminderFeeLabel}
                  name={"debtNoteLastReminderFee"}
                  registerName={"debtNoteLastReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.lastReminderPaymentPeriod")}
                  name={"debtNoteLastReminderPeriod"}
                  registerName={"debtNoteLastReminderPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
          </div>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.pumpSwappedPaymentInfoTitle")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={additionalFeeLabel}
                  name={"pumpSwappedAdditionalFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      pumpSwappedAdditionalFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.paymentPeriod")}
                  name={"pumpSwappedPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      pumpSwappedPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={reminderFeeLabel}
                  name={"pumpSwappedReminderFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      pumpSwappedReminderFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.reminderPaymentPeriod")}
                  name={"pumpSwappedReminderPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      pumpSwappedReminderPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={lastReminderFeeLabel}
                  name={"pumpSwappedLastReminderFee"}
                  registerName={"pumpSwappedLastReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.lastReminderPaymentPeriod")}
                  name={"pumpSwappedLastReminderPeriod"}
                  registerName={"pumpSwappedLastReminderPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
          </div>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("GasStations.otherReasonPaymentInfoTitle")}
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={additionalFeeLabel}
                  name={"otherReasonAdditionalFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      otherReasonAdditionalFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.paymentPeriod")}
                  name={"otherReasonPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      otherReasonPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>

            <div className={Style.gsPaymentInfoContainer}>
              <InputController
                  containerStyles={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
                  label={reminderFeeLabel}
                  name={"otherReasonReminderFee"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      otherReasonReminderFee: e.target.value,
                    });
                  }}
              />

              <InputController
                  containerStyles={Style.container}
                  label={t("GasStations.reminderPaymentPeriod")}
                  name={"otherReasonReminderPaymentPeriod"}
                  control={control}
                  controllerClassName={Style.textStyleInputEditModal}
                  type={"number"}
                  min={0}
                  onChange={(e) => {
                    setCategoryPaymentDetails({
                      ...categoryPaymentDetails,
                      otherReasonReminderPaymentPeriod: e.target.value,
                    });
                  }}
              />
            </div>
            <div className={Style.gsPaymentInfoContainer}>
              <div className={cn(
                  Style.container,
                  Style["container--margineRight"]
              )}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={lastReminderFeeLabel}
                  name={"otherReasonLastReminderFee"}
                  registerName={"otherReasonLastReminderFee"}
                  register={register}
                  type={"number"}
                  min={0}
              /></div>

              <div className={Style.container}>
                <InputFieldWithLabel
                  className={Style.textStyleInputEditModal}
                  label={t("GasStations.lastReminderPaymentPeriod")}
                  name={"otherReasonLastReminderPeriod"}
                  registerName={"otherReasonLastReminderPeriod"}
                  register={register}
                  type={"number"}
                  min={0}
                />
              </div>
            </div>
          </div>
          </>
          ) : (
          <>
            <div className={Style.section}>
              <div className={Style.section__title}>
                {t("GasStations.paymentAndFeeDetails")}
              </div>

              <div className={Style.gsPaymentInfoContainer}>
                
                {!isSelectedCountryAT() && <div className={cn(
                    Style.container,
                    Style["container--margineRight"],
                )}>
                    <InputFieldWithLabel
                        className={Style.textStyleInputEditModal}
                        label={serviceFeeLabel}
                        name={"serviceFee"}
                        registerName={"serviceFee"}
                        register={register}
                        required={!isSelectedCountryCH()}
                        validationProps={!isSelectedCountryCH() ? {
                            required: t("Validation.required"),
                            min: { value: 0, message: t("Validation.minValueZero") }
                          }
                          :{}}
                        type="number"
                        min={0}
                        errors={errors}
                      />
                </div>}

                  {!isSelectedCountryAT() && <div className={Style.container}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={holderDataRetrievalLabel}
                    name={"holderDataRetrieval"}
                    registerName={"holderDataRetrieval"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                  />
                </div>}
              </div>

              <div className={Style.gsPaymentInfoContainer}>
                {!isSelectedCountryAT() && <div className={cn(
                    Style.container,
                    Style["container--margineRight"]
                )}>
                   <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.rvgMultiplierInvoice")}
                    name={"rvgMultiplierInvoice"}
                    registerName={"rvgMultiplierInvoice"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                /></div>}

                <div className={Style.container}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.paymentPeriod")}
                    name={"invoicePaymentPeriod"}
                    registerName={"invoicePaymentPeriod"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={!isSelectedCountryCH()}
                    validationProps={!isSelectedCountryCH() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                  />
                </div>
              </div>

              <div className={Style.gsPaymentInfoContainer}>
                {!isSelectedCountryAT() && <div className={cn(
                    Style.container,
                    Style["container--margineRight"]
                )}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.rvgMultiplierReminder")}
                    name={"rvgMultiplierReminder"}
                    registerName={"rvgMultiplierReminder"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE()? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                /></div>}

                  <div className={Style.container}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.reminderPaymentPeriod")}
                    name={"reminderPaymentPeriod"}
                    registerName={"reminderPaymentPeriod"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={!isSelectedCountryCH()}
                    validationProps={!isSelectedCountryCH() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                  />
                </div>
              </div>

              <div className={Style.gsPaymentInfoContainer}>
                {!isSelectedCountryAT() &&<div className={cn(
                    Style.container,
                    Style["container--margineRight"]
                )}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.rvgMultiplierLastReminder")}
                    name={"rvgMultiplierLastReminder"}
                    registerName={"rvgMultiplierLastReminder"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                /></div>}

                <div className={Style.container}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={t("GasStations.lastReminderPaymentPeriod")}
                    name={"lastReminderPaymentPeriod"}
                    registerName={"lastReminderPaymentPeriod"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={!isSelectedCountryCH() }
                    validationProps={!isSelectedCountryCH() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                  />
                </div>
              </div>

              <div className={Style.gsPaymentInfoContainer}>
                {!isSelectedCountryAT() &&<div className={cn(
                    Style.container,
                    Style["container--margineRight"]
                )}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={baseFeeLabel}
                    name={"baseFee"}
                    registerName={"baseFee"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                /></div>}

                {!isSelectedCountryAT() &&<div className={Style.container}>
                  <InputFieldWithLabel
                    className={Style.textStyleInputEditModal}
                    label={capBelow50Label}
                    name={"capBelow50"}
                    registerName={"capBelow50"}
                    register={register}
                    type={"number"}
                    min={0}
                    required={isSelectedCountryDE()}
                    validationProps={isSelectedCountryDE() ? {
                        required: t("Validation.required"),
                        min: { value: 0, message: t("Validation.minValueZero") }
                      }
                      :{}}
                    errors={errors}
                  />
                </div>}
              </div>
            </div>

          </>
          )}


          <div className={cn(Style.section, Style["section--payment"])}>
            <div className={Style.section__title}>
              {t("ParkingZones.paymentInfo")}
            </div>
            <div className={Style.paymentSection__rowContainer}>
              <div
                  className={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
              >
                <InputFieldWithLabel
                    label="IBAN"
                    name="iban"
                    registerName="iban"
                    register={register}
                />
              </div>
              <div
                  className={cn(Style.container, Style["container"])}
              >
                <InputFieldWithLabel
                    label="BIC"
                    name="bic"
                    registerName="bic"
                    register={register}
                />
              </div>
            </div>
            <div className={Style.paymentSection__rowContainer}>
              <div
                  className={cn(
                      Style.container,
                      Style["container--margineRight"]
                  )}
              >
                <InputFieldWithLabel
                    label={t("ParkingZones.Payee")}
                    name="payee"
                    registerName="payee"
                    register={register}
                />
              </div>
              <div
                  className={cn(Style.container, Style["container"])}
              >
                <InputFieldWithLabel
                    label={t("ParkingZones.FinancialInstitution")}
                    name="financialInstitution"
                    registerName="financialInstitution"
                    register={register}
                />
              </div>
            </div>

            <div className={Style.paymentSection__rowContainer}>
                <div
                    className={cn(
                        Style.container,
                        Style["container--margineRight"]
                    )}
                >
                    <LabelWithHR label={t("ParkingZones.contractDate")}/>
                    <Controller
                        name="contractDate"
                        control={control}
                        render={() => (
                            <DatePicker
                                selected={contractDate}
                                dateFormat="dd.MM.yyyy"
                                popperPlacement="top"
                                className={Style.textStyleInputEditModal}
                                locale="de"
                                onChange={(date) => setContractDate(date)}
                            />
                        )}
                    />
                </div>
                <div
                    className={cn(Style.container, Style["container"])}
                >
                    <InputFieldWithLabel
                        label={t("ParkingZones.salesArea")}
                        name="salesArea"
                        registerName="salesArea"
                        register={register}
                    />
                </div>
            </div>
          </div>

          <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "30px",
                marginLeft: "30px",
                justifyContent: "space-between",
              }}
          >
            <div style={{flex: 1}}>
              <TextareaWithLabel
                  label={t("GasStations.Others")}
                  name="others"
                  textAreaStyle={{
                    minHeight: "60px",
                    boxShadow: "none",
                    border: "1px solid #c7c7c7",
                  }}
                  registerName="others"
                  register={register}
              />
            </div>
          </div>

          <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "30px",
                marginLeft: "30px",
                justifyContent: "space-between",
              }}
          >
            <div style={{flex: 1}}>
              <InputFieldWithLabel
                  label={t("GasStations.RepresentedBy")}
                  name="representedBy"
                  registerName="representedBy"
                  register={register}
              />
            </div>
            <div style={{flex: 1, marginLeft: "40px"}}>
              <InputFieldWithLabel
                  label={t("GasStations.RelationToProperty")}
                  name="relationToProperty"
                  registerName="relationToProperty"
                  register={register}
              />
            </div>
          </div>

          <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "30px",
                marginLeft: "30px",
                justifyContent: "space-between",
              }}
          >
            <div style={{flex: 1}}>
              <TextareaWithLabel
                  label={t("GasStations.NotedBy")}
                  name="notedBy"
                  textAreaStyle={{
                    minHeight: "60px",
                    boxShadow: "none",
                    border: "1px solid #c7c7c7",
                  }}
                  registerName="notedBy"
                  register={register}
              />
            </div>
          </div>
          <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "30px",
                marginLeft: "30px",
                justifyContent: "space-between",
              }}
          >
            <div style={{flex: 1}}>
              <TextareaWithLabel
                  label={t("GasStations.InjuredPerson")}
                  name="injuredPerson"
                  textAreaStyle={{
                    minHeight: "60px",
                    boxShadow: "none",
                    border: "1px solid #c7c7c7",
                  }}
                  registerName="injuredPerson"
                  register={register}
              />
            </div>
          </div>
          <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "30px",
                marginLeft: "30px",
                justifyContent: "space-between",
              }}
          >
            <div style={{flex: 1}}>
              <TextareaWithLabel
                  label={t("GasStations.AdditionalInfo")}
                  name="additionalInfo"
                  textAreaStyle={{
                    minHeight: "60px",
                    boxShadow: "none",
                    border: "1px solid #c7c7c7",
                  }}
                  registerName="additionalInfo"
                  register={register}
              />
            </div>
          </div>

          <div className={Style.section}>
            <div className={Style.section__title}>
              {t("ParkingZones.documents")}
            </div>
            <div className={Style.container}>
              <>
                <label htmlFor="file-upload" className={Style.fileUpload}>
                  {t("GasStations.PowerOfAttorney")}
                </label>
                {powerOfAttorneyName !== "" && (
                    <label>
                      {powerOfAttorneyName === "" ? null : (
                          <div>
                            {showDocumentsNames(
                                powerOfAttorney,
                                setPowerOfAttorney,
                                powerOfAttorneyName,
                                setPowerOfAttorneyName
                            )}
                          </div>
                      )}
                    </label>
                )}

                <input
                    id="file-upload"
                    type="file"
                    accept="image/jpg, image/png, image/jpeg"
                    className="powerOfAttorney"
                    onChange={(e) => {
                      documentUpload(
                          e,
                          powerOfAttorney,
                          setPowerOfAttorney,
                          powerOfAttorneyName,
                          setPowerOfAttorneyName,
                          true
                      );
                    }}
                    multiple={false}
                />
                <label htmlFor="documentation" className={Style.fileUpload}>
                  {t("GasStations.GSDocumentation")}
                </label>
                {documentationName !== "" && (
                    <label>
                      {documentationName === "" ? null : (
                          <div>
                            {showDocumentsNames(
                                documentation,
                                setDocumentation,
                                documentationName,
                                setDocumentationName
                            )}
                          </div>
                      )}
                    </label>
                )}
                <input
                    id="documentation"
                    type="file"
                    accept=".pdf, .docx"
                    className="documentation"
                    multiple
                    onChange={(e) => {
                      documentUpload(
                          e,
                          documentation,
                          setDocumentation,
                          documentationName,
                          setDocumentationName,
                          false
                      );
                    }}
                />
              </>
            </div>
          </div>

          <div className={Style.section}>
            <div
                className={cn(
                    Style.section__title,
                    Style["section__title--admin"]
                )}
            >
              {t("ParkingZones.chooseAdmin")}
            </div>

            {isLoggedUserSysadmin ? (
                <Controller
                    name="keycloakAdminId"
                    control={control}
                    render={() => (
                        <Autocomplete
                            size="small"
                            id={"keycloakAdminId"}
                            onChange={(e, value) => {
                              if (value) {
                                setGasStationAdmin(value.id);
                              }
                            }}
                            disableClearable
                            value={admins.find(x => x.id === keycloakAdminId) || null}
                            renderInput={(params) => <TextField {...params} placeholder={"auswählen"}/>}
                            options={admins}
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={(x) => `${x.firstName} ${x.lastName} | ${x.emailAddress} ${x.companyName ? "| " + x.companyName : ""}`}
                        />
                    )}
                />
            ) : (
                <div className={Style.text}>
                  {loggedUser?.firstName + " " + loggedUser?.lastName}
                </div>
            )}

            <div
                className={cn(
                    Style.section__title,
                    Style["section__title--admin"]
                )}
            >
              {"PZ Manager"}
            </div>

            {renderManagers()}

            <button
                type="button"
                className={
                  managersIds?.includes("0")
                      ? cn(
                          Style.addManagerButton,
                          Style["addManagerButton--disabled"]
                      )
                      : cn(
                          Style.addManagerButton,
                          Style["addManagerButton--enabled"]
                      )
                }
                onClick={() => {
                  setManagersIds([...managersIds, "0"]);
                  setManagersComboBoxNames([
                    ...managersComboBoxNames,
                    counter + 1,
                  ]);
                  setCounter(counter + 1);
                }}
                disabled={managersIds?.includes("0")}
            >
              {"+ Neue Manager" /*TODO translation*/}
            </button>

            <div className={Style.buttonContainer}>
              <Button
                  style={{
                    width: "25%",
                  }}
                  buttonStyle={{
                    width: "100%",
                  }}
                  disabled={isSubmitDisabled}
                  text={t("GasStations.saveGasStation")}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};
export default AddGasStationModal;
